import * as React from "react";
import {Suspense} from "react";
import {CustomerServiceNotice} from "./customerServiceNotice";
import {AskQuestionForm} from "./askQuestionForm";

export const ZeroQuestions = () => (
    <div className="p-3 text-center">
        <strong className="fs-4">No questions have been asked yet. Ask a Question!</strong>
        <CustomerServiceNotice/>
        <Suspense>
            <AskQuestionForm/>
        </Suspense>
    </div>
);